var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"other_box",domProps:{"innerHTML":_vm._s(_vm.column_content.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }